import { render, staticRenderFns } from "./scoreList.vue?vue&type=template&id=99b66de4&scoped=true&"
import script from "./scoreList.vue?vue&type=script&lang=js&"
export * from "./scoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b66de4",
  null
  
)

export default component.exports